module.exports = __webpack_public_path__ + "img/32.97878d1f.png";